module.exports = __webpack_public_path__ + "img/logo-icon-10e.0e7a93f9.png";